//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function updateProductService(formData) {
  try {
    const temId = [formData.id_produto_hotmart, formData.id_produto_kiwify, formData.id_produto_lastlink].some(v => v && String(v).trim());
    if (!formData.id || !formData.nome || !temId) {
        toast.warn("Informe o nome e o ID do produto em pelo menos uma plataforma");
        return false;
}
    await api.put(`/produtos/${formData.id}`, formData);
    toast.success("Produto atualizado com sucesso");
    return true;
  } catch (error) {
    toast.error(error?.response?.data?.error || "Erro ao atualizar produto");
    return false;
  }
}